// Browser polyfills
import 'babel-polyfill';
import 'whatwg-fetch';

// Libs
import React from 'react';
import { render } from 'react-dom';

// Redux
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

// Bridge
import { Bridge } from '@nackle/bridge';

// Apollo
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

// Routing
import { Route, routeHistory } from '@nackle/biw-web-router';
import { routes, getMiddleware as getRouteMiddleware } from './app-routing.jsx';

// Utils
import { companySetupURL } from 'endpoints';

import auth, { authRequestMiddleware } from './app-auth';

import './styles/style.scss';
import { applyRequestMiddleware } from './utils/fetch.js';

const store = createStore(
    applyMiddleware( thunk )
 );

const httpLink = createHttpLink( {
    uri: `${ companySetupURL }/graphql`
} );

const authLink = setContext( ( _, { headers } ) => {
    const token = auth.state.access_token;

    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${ token }` : ''
        }
    };
} );

const apolloClient = new ApolloClient( {
    link: authLink.concat( httpLink ),
    cache: new InMemoryCache( {
        addTypename: false
    } )
} );




/*******************************************************************************
 *  1. App (root level component)
 */

class App extends React.Component {

    state = {
        user: {}
    };

    handleSignIn = ( user ) => {
        console.log( 'user claims is:', user?.claims );
        if ( user.claims ) {
            this.setState( { user: user.claims } );
        }
    };


    handlePermissionChange = ( permissions ) => {
        // Permissions.setPermissions( permissions );
    };


    render() {
        return (
            <Route render={ ( route ) => {
                return (
                    <Bridge
                        auth={ auth }
                        onSignIn={ this.handleSignIn }
                        onRefresh={ this.handleSignIn }
                        onPermissionsChanged={ this.handlePermissionChange }
                    >
                        <div className="app-container">
                            <div>
                            {
                                route.match
                                ? route.component
                                : <h1>Page Not Found</h1>
                            }
                            </div>
                        </div>
                    </Bridge>
                );
            } }/>
        );
    }
}


/*******************************************************************************
 *  2. Connect Routing
 */
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( getRouteMiddleware( /* AppStore */ ) );

/********************************************************************************
 * 3. connect Auth to fetch
 */
applyRequestMiddleware( authRequestMiddleware );

/*******************************************************************************
 * 4. Render the the app
 */

render(
    <ApolloProvider client={ apolloClient }>
        <Provider store={ store }>
            <App />
        </Provider>
    </ApolloProvider>,
    document.getElementById( 'app-root' )
);